import React, { useEffect, useState } from "react";
import { useLocation } from "@reach/router";
import { animateScroll } from "react-scroll";

const ScrollToTopWrapper = ({ children }) => {
  const location = useLocation();
  const [targetHash, setTargetHash] = useState(null);

  const scrollUp = () => {
    // console.log("I'm scrolling up...");
    const options = {
      smooth: false
    };

    animateScroll.scrollToTop(options);
  };

  const smartScrollUp = () => {
    // console.log("I'm smart scrolling up...");
    const options = {
      smooth: false,
      isDynamic: true,
      delay: 100
    };

    animateScroll.scrollToTop(options);
  };

  const scrollToHash = (hash, needsDelay) => {
    const id = hash.substring(1); // Remove the '#'
    const element = document.getElementById(id);

    if (element) {
      // console.log("Scroll to the hash element");
      const options = {
        smooth: true,
        isDynamic: needsDelay,
        delay: needsDelay ? 500 : 0,
        containerId: id
      };

      animateScroll.scrollTo(id, options);
    } else {
      // console.warn(`Element with id '${id}' not found.`);
    }
  };

  const changeLocationScrollUp = () => {
    // console.log("Location:", location);

    // If we have more pages with dynamic content or with issues going up with the scrollUp method
    // we can add it in here, you don't need to add the full location with hash, just the pathname
    const LOCATIONS_TO_FORCE_SCROLL_UP = ["/privacy-center", "/privacy-center/"];

    const forceLocation = LOCATIONS_TO_FORCE_SCROLL_UP.includes(location.pathname);

    // Check for hash on initial load and page path changes
    setTimeout(() => {
      if (!location.hash) {
        // console.log("It doesn't have a hash, I go up");
        // If no hash, scroll to top on page navigation
        if (forceLocation) smartScrollUp();
        else scrollUp();

        setTargetHash(null); // Clear the target hash
      } else {
        setTargetHash(location.hash);
        // scrollToHash(location.hash, forceLocation);
        // console.log("It does have a hash, I go to the hash");
      }
    }, 0);
  };

  const changeTargetHashScrollUp = () => {
    if (targetHash) {
      // Use requestAnimationFrame for more reliable timing
      requestAnimationFrame(() => {
        const targetId = targetHash.substring(1);
        const targetElement = document.getElementById(targetId);
        // console.log("Target hash: ", targetId);
        // console.log("Target element: ", targetElement);
        if (targetElement) {
          // console.log("Content found.");
          scrollToHash(targetId, true);
          // targetElement.scrollIntoView({ behavior: 'smooth' });
        } else {
          smartScrollUp();
          // console.log("Content NOT found.");
        }
        setTargetHash(null); // Clear the target hash
      });
    }
  };

  // We try to scroll up when changing the location
  useEffect(() => {
    changeLocationScrollUp();
  }, [location]);

  useEffect(() => {
    changeTargetHashScrollUp();
  }, [targetHash]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
      changeLocationScrollUp();
      changeTargetHashScrollUp();
    }
  }, []);

  return <>{children}</>;
};

export default ScrollToTopWrapper;
